import {AfterContentInit, Directive, Inject, Input, OnInit} from 'ng-metadata/core';
import {isBrowserIE} from './browserSniffer';
import {getSuspendWatchersActivatedForBrowser} from '../appConfig/appConfigForward';

/*
    This is a performance optimization directive.
    To use this directive add the following attributes to an html element:
    prm-digest-when-in-view in-view="$ctrl.onInView(undefined, $inview, $inviewInfo)" in-view-options="{throttle: 50}"

    This will disable angular change detection for all the scope subtree starting with the scope associated with the html element this was placed upon.
    When the element comes into view the change detection will be enabled.
 */
@Directive({
    selector: '[prm-digest-when-in-view]',

})

export class PrmDigestWhenInView implements AfterContentInit, OnInit{

    @Input() digestWhenInViewDisabled: boolean;
    private digestWhenInViewConfigured : boolean;
    constructor(@Inject('$element') private $element: JQuery,
                @Inject('$scope') private $scope: ng.IScope) {
        this.digestWhenInViewConfigured = (getSuspendWatchersActivatedForBrowser() === "ALL") || (getSuspendWatchersActivatedForBrowser() === "IE" && isBrowserIE());
    }

    ngOnInit(): any {
        if (!this.digestWhenInViewDisabled && this.digestWhenInViewConfigured){
            this.$scope.$ctrl.onInView= (data, $inview, $inviewInfo)=>{
                if ($inview){
                    this.$scope.$resume();
                }
                else if(!this.digestWhenInViewDisabled){
                    this.$scope.$suspend();
                }
            };
        }
    }
    ngAfterContentInit(): any {
        if (!this.digestWhenInViewDisabled && this.digestWhenInViewConfigured){
            this.$scope.$suspend();
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/digestWhenInView.directive.ts